import * as proto from 'src/proto/compiled-protos';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TitleComponent } from 'src/app/general/components/title/title.component';
import { ComponentUtil } from 'src/app/general/util/component-util';
import { Util } from 'src/app/general/util/util';

// ----------------------------------------------------------------------------
// Adds a device header. If the device id is provided the device is loaded.
// If the device proto is provided the data is taken from such device.

// Usage Example

// Template:

// <app-device-header [deviceId]="deviceId"></app-device-header>
// <app-device-header [device]="device"></app-device-header>
// ----------------------------------------------------------------------------

@Component({
  selector: 'app-device-header',
  standalone: true,
  imports: [
    CommonModule,
    TitleComponent
  ],
  templateUrl: './device-header.component.html',
  styleUrls: ['./device-header.component.css']
})
export class DeviceHeaderComponent implements OnInit, OnChanges {
  @Input() deviceId?: string;
  @Input() device?: proto.waiternow.common.IDeviceProto;

  headerText: string;

  constructor() {
    this.headerText = '';
  }

  ngOnInit(): void {
    if (this.device) {
      this.headerText = Util.safeString(this.device.id);
    } else if (this.deviceId) {
      this.headerText = this.deviceId;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (ComponentUtil.bindingChanged('deviceId', changes)
       || ComponentUtil.bindingChanged('device', changes)) {
      this.ngOnInit();
    }
  }
}
